import PropTypes from "prop-types";
import {useContext, useRef, useEffect, useLayoutEffect, useCallback, useState} from 'react';
import {NavContext} from "@/core/providers/NavProvider";

const StickyMainNav = ({children}) => {

    const { stickyMenu } = useContext(NavContext);
    const [subNav] = stickyMenu;
    const [sticky, setSticky] = useState(false);
    const [scrollUp, setScrollUp] = useState()

    const navWrapper = useRef();
    const navElement = useRef();
    const navHeight = useRef()

    const lastScroll = useRef(0);

    useLayoutEffect(()=>{

        /** secure the height of the element wrapping the nav, so that when the nav
         * goes fixed, it's previously occupied space keeps its height */

        if(navWrapper.current && navElement.current){
            navHeight.current = `${navElement.current.offsetHeight}px`
            navWrapper.current.style.minHeight = navHeight.current;
            navWrapper.current.style.height = navHeight.current;
        }

    }, [])

    const checkDirection = useCallback(() => {

        let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if (scrollTop > lastScroll.current){
            // downscroll code
            if(scrollUp){
                // console.log('Down');
                setScrollUp(false);
            }

        } else {
            // upscroll code
            if(!scrollUp){
                // console.log('Up');
                setScrollUp(true);
            }
        }
        lastScroll.current = scrollTop <= 0 ? 0 : scrollTop; // For Mobile or negative scrolling
    }, [scrollUp]);

    const checkSticky = useCallback(() => {

        let checkpoint = scrollUp ? 0 : navWrapper.current.offsetHeight;

        let activate = (window.scrollY - navWrapper.current.offsetTop) >= checkpoint;

        if(sticky !== activate){
            setSticky(activate);
        }

    }, [sticky,setSticky,scrollUp])

    const scrollCheck = useCallback(() => {
        checkDirection();
        checkSticky();
    }, [checkDirection,checkSticky]);

    useEffect(()=>{

        window.addEventListener('scroll', scrollCheck)
        return ()=>window.removeEventListener('scroll', scrollCheck)
    }, [scrollCheck])

    let stickyClass = {
        position: sticky ? 'fixed' : 'relative',
        width: '100%',
        zIndex: 999,
        background: '#fff',
        boxShadow: '0px 1px 20px rgba(0, 0, 0, 0.05)',
        '&.animate': {
            top: `-${navHeight.current}`,
            transition: 'top 1s',

        },
        '&.up': {
            top: 0,
        },

        '&.down': {
            top: `-${navHeight.current}`,
        }
    }

    const upDownClass = () => {
        if(sticky){
            return `animate ${scrollUp ? 'up' : 'down'}`
        }
    }

    return (
        <div id={'StickyMainNav'} ref={navWrapper}>
            <div css={stickyClass} className={upDownClass()}>
                <div ref={navElement}>
                    {children}
                </div>
                {subNav}
            </div>
        </div>
    )
}

StickyMainNav.propTypes = {
    children: PropTypes.object
}

export default StickyMainNav